<template>
  <div class="w-100" :class="{'hasErr': validation}">
    <label> <span class="text-danger">*</span> Bài học</label>
    <vSelect
        v-model="questionId"
        placeholder="Lựa chọn câu hỏi"
        :disabled="disableSelect"
        :options="questionList"
        label="content"
        :class="{'is-invalid': validation}"
        :reduce="(question) => question.id"
        class="w-100"
        :multiple="isMultiple"
        @search="(query)=> queryKeyword(query)"
        @close="$emit('onClose')"
    >
      <template #list-footer>
        <li v-show="hasNextPage" ref="load" class="loader text-center">
          loading...
        </li>
      </template>
    </vSelect>
    <span class="invalid-feedback">{{ messageErr }}</span>
  </div>
</template>
<script>
import vSelect from 'vue-select';
import {ListQuestion} from "@/services/exam";
import CONFIG_APP from "@/configs";

export default {
  expose: ['resetData'],
  name: "Question-select",
  components: {vSelect},
  props: {
    messageErr: {type: String, default: 'Vui lòng chọn bài học.'},
    validation: Boolean,
    modelValue: Array,
    idOld: {type: Array, default: null},
    isMultiple: {type: Boolean, default: true}
  },
  data() {
    return {
      questionId: [],
      hasNextPage: false,
      disableSelect: false,
      questionList: [],
      page: 1
    }
  },
  computed: {
    per_page: () => {
      return CONFIG_APP.itemOnPage
    }
  },
  watch: {
    questionId() {
      this.$emit('selected', this.questionId)
      this.$emit('update:modelValue', this.questionId)
    },
    questionList() {
      this.questionId = this.modelValue
    }
  },
  created() {
    this.getMaterial()
  },

  methods: {
    getMaterial(params) {
      this.hasNextPage = true
      if (!params) {
        params = {per_page: this.per_page, page: this.page}
      }
      ListQuestion(params).then(e => {
        if (e.data.status === 'success') {
          let data = e.data.data.questions.data
          if (this.idOld) {
            this.idOld.map(item => {
              let index = data.findIndex(el => el.id === item.id)
              if (index > -1) {
                data.splice(index, 1)
              }
            })
          }
          this.questionList = data
          this.disableSelect = false
          this.hasNextPage = false
        }
      }).catch(err => {
        if (err.response.data == 'failed') {
          location.reload();
        }
      })
    },
    queryKeyword(query) {
      this.subjects = []
      this.hasNextPage = true
      let params = {per_page: this.per_page, page: 1, keyword: query}
      this.getMaterial(params)
    },
    resetData() {
      this.questionId = null
    }
  },

}
</script>
<style scoped lang="scss">
.hasErr {
  .is-invalid {
    ::v-deep .vs__dropdown-toggle {
      border-color: red;
    }
  }
}
</style>
